import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const EntityCounter = ({size, entityName}) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                px: 1,
                border: 1,
                borderRadius: 1,
                color: "grey.700",
                textTransform: "uppercase",
            }}
        >
            <Typography
                component="span"
                variant="h6"
                sx={{
                    mr: 1,
                }}
            >
                {size}
            </Typography>
            <Typography variant="subtitle1">{entityName}</Typography>
        </Box>
    );
};

export default EntityCounter;
